// src/features/management/routes.tsx
import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@/app/routing/rootRoute';
import MenusPage from './pages/menus/Menus';
import SubMenusPage from './pages/subMenu/SubMenu';
import UsersPage from './pages/users/Users';
import Roles from './pages/roles/Roles';
import ActionsPage from './pages/actions/ActionsPage';
import UserFormPage from './pages/users/UserForm';
import MenuForm from './pages/menus/MenuForm';
import SubMenuForm from './pages/subMenu/SubMenuForm';
import RoleForm from './pages/roles/RoleForm';
import RolePermissions from './pages/roles/RolePermissions';
import ChangePasswordPage from './pages/users/ChangePasswordPage';


export const managementRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/management',
});

export const managementMenusRoute = createRoute({
  getParentRoute: () => managementRoute,
  path: '/menus',
  component: MenusPage,
});

export const managementSubMenusRoute = createRoute({
    getParentRoute: () => managementRoute,
    path: '/sub-menu',
    component: SubMenusPage,
});

export const managementSubMenusForm = createRoute({
    getParentRoute: () => managementRoute,
    path: '/sub-menu/form',
    component: SubMenuForm,
});

export const managementMenusFormRoute = createRoute({
  getParentRoute: () => managementRoute,
  path: '/menus/form',
  component: MenuForm,
});

export const managementActionsRoute = createRoute({
  getParentRoute: () => managementRoute,
  path: '/actions',
  component: ActionsPage,
});

export const managementUsersRoute = createRoute({
  getParentRoute: () => managementRoute,
  path: '/users',
  component: UsersPage,
});

export const managementUserFormRoute = createRoute({
  getParentRoute: () => managementRoute,
  path: '/users/form', 
  component: UserFormPage,  
});

export const managementChangePasswordRoute = createRoute({
    getParentRoute: () => managementRoute,
    path: '/users/change-password',
    component: ChangePasswordPage,
});


export const managementRolesRoute = createRoute({
  getParentRoute: () => managementRoute,
  path: '/roles',
  component: Roles,
});

export const managementRoleFormRoute = createRoute({
    getParentRoute: () => managementRoute,
    path: '/roles/form',
    component: RoleForm,
});

export const managementRolePermissionsRoute = createRoute({
    getParentRoute: () => managementRoute,
    path: '/roles/permissions',
    component: RolePermissions,
   
});

export const managementRoutes = [
  managementRoute,
    managementMenusRoute,
    managementSubMenusRoute,
  managementActionsRoute,
  managementUsersRoute,
  managementUserFormRoute,
    managementRolesRoute,
    managementRoleFormRoute,
    managementMenusFormRoute,
    managementSubMenusForm,
    managementRolePermissionsRoute,
    managementChangePasswordRoute,
];